import type { ResourcesConfig } from "aws-amplify";

const region = process.env.NEXT_PUBLIC_COGNITO_REGION;
const userPoolId = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID;
const userPoolClientId = process.env.NEXT_PUBLIC_COGNITO_APP_CLIENT_ID;
const hostedDomain = process.env.NEXT_PUBLIC_COGNITO_HOSTED_UI_DOMAIN;

if (!region || !userPoolId || !userPoolClientId || !hostedDomain) {
  throw new Error(
    "Missing required Cognito env vars. Copy .env.example to .env.local and fill in values."
  );
}

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      loginWith: {
        oauth: {
          domain: hostedDomain,
          scopes: ["openid", "email", "profile", "aws.cognito.signin.user.admin"],
          // NOTE (Step 12.5 DNS cutover): keep these in lockstep with the
          // Cognito app-client CallbackURLs / LogoutURLs. Amplify picks the
          // entry whose origin matches window.location.origin, so the CURRENT
          // prod origin must be present or signInWithRedirect throws before
          // reaching Google. magnaflor-portal.vercel.app is the live origin
          // today; magnaflor.com is the post-cutover canonical (PASTE #252,
          // added additively ahead of the flip); portal.magnaflor.com is the
          // legacy subdomain kept for old links.
          redirectSignIn: [
            "http://localhost:3000/auth/callback",
            "https://magnaflor-portal.vercel.app/auth/callback",
            "https://magnaflor.com/auth/callback",
            "https://portal.magnaflor.com/auth/callback",
          ],
          redirectSignOut: [
            "http://localhost:3000",
            "https://magnaflor-portal.vercel.app",
            "https://magnaflor.com",
            "https://portal.magnaflor.com",
          ],
          responseType: "code",
        },
      },
    },
  },
};
